import service from '@/store/services/model_app-service';

const state = {
  list: {},
  model_app: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, model_app) => {
    state.model_app = model_app;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((model_app) => { commit('SET_RESOURCE', model_app); });
  },
  

  listByDivision({commit, dispatch}, params) {
    return service.listByDivision(params)
      .then((model_app) => { commit('SET_RESOURCE', model_app); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((model_app) => { commit('SET_RESOURCE', model_app); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((model_app) => { commit('SET_RESOURCE', model_app); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  model_app: state => state.model_app,
};
 
const model_app = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default model_app;
